import React, {useState, useEffect} from 'react';
import {Box, Typography, IconButton, Collapse, Divider} from '@mui/material';
import PayuForm from './PayuForm';
import {PAGELIST_ID} from '@jobseeker/common-core/constants';
import {useRouter} from 'next/router';
import {useWrappedTheme} from '@jobseeker/lotus/hooks';
import {Image} from '@jobseeker/lotus/components/Image';

const ProButton = () => {
  const router = useRouter();
  const isRetry = router.query.retryboth === 'true';
  return (
    <Box sx={{marginTop: 2, display: 'inline-block'}}>
      <PayuForm
        key={'pro_membership_plan_button'}
        title={'Buy Now @1499 for 6 months'}
        refCode="0"
        pageId={PAGELIST_ID['jd']}
        tracking={{action: 'jsSCbanner', category: 'UpgradeToPro'}}
        product={'2,3'}
        useLink={true}
        autoTrigger={isRetry}
      />
    </Box>
  );
};

const FAQquestions = [
  {
    question: 'Can I buy both the plans together?',
    description: (
      <>
        Yes, you can buy both the plans together. In fact, you can save Rs.
        499/- if you buy both the subscription. To subscribe to both early
        applicant and resume builder,
        <Box sx={{display: 'inline-block', margin: '-40px 3px'}}>
          {<ProButton />}
        </Box>
        and save Rs. 499/- on your overall subscription price.
      </>
    ),
  },
  {
    question: 'How do I benefit from Early Applicant Subscription?',
    description: (
      <>
        Early Applicant feature helps you apply to the job you desire. As soon
        as a job based on your preference is published on the platform, we
        notify you. You can apply to these jobs earlier than your competitors
        and get an edge over them. Candidates who apply early have a higher
        chance of being noticed by employers.
      </>
    ),
  },
  {
    question: 'How do I benefit from Resume Builder Tool?',
    description: (
      <>
        Resume Builder tool is an easy-to-use framework that helps you create
        your resume from the profile you have created. The more details you add
        while creating the profile, the faster you can create a resume. Resumes
        made through iimjobs resume builder are easy to scan by recruiters as
        they reduce the clutter and segregate your details in specified sections
        in a visually appealing manner. We also show you tips from our experts
        when you are building your resume, making your resume writing journey
        smooth and insightful.
      </>
    ),
  },
  {
    question: 'Will any of the subscription plans guarantee a job interview?',
    description: (
      <>
        No, we do not guarantee any interview calls with the subscription. These
        subscription plans are to help you in your job search and to get noticed
        by employers. However, it is the recruiter who decides whom to
        call/interview/hire based on various factors.
      </>
    ),
  },
];

const FAQ = () => {
  const [extendClass, setExtendClass] = useState([1, 0, 0, 0]);
  const theme = useWrappedTheme();

  const handleAnimation = indexNum => {
    let updatedClass = extendClass.map((_, idx) => (idx === indexNum ? 1 : 0)); // Collapse all except the clicked one

    // If the clicked FAQ is already open, close it and open the first FAQ
    if (extendClass[indexNum] === 1) {
      updatedClass = updatedClass.map(() => 0); // Close all FAQs
      updatedClass[0] = 1; // Open the first FAQ
    }

    setExtendClass(updatedClass);
  };

  const FAQquestionsWrapper = (i, question, description) => (
    <Box key={i} sx={{paddingBottom: '24px'}}>
      <Box sx={{display: 'flex', alignItems: 'flex-start'}}>
        <Box
          sx={{
            width: '32px',
            height: '32px',
            borderRadius: '50%',
            backgroundColor: 'primary.contrastText',
            border: 'solid 1px #e7e7e7',
            marginRight: '12px',
            display: {
              xs: 'none',
              sm: 'none',
              md: 'flex',
            },
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: theme.typography.pxToRem(16),
          }}
        >
          {i + 1}
        </Box>

        <Box
          sx={{
            width: 'calc(100% - 18px)',
            borderBottom:
              i === FAQquestions.length - 1
                ? 'none'
                : '2px solid rgba(0,0,0,.1)',
          }}
        >
          {/* Question Title */}
          <Typography
            sx={{
              fontSize: theme.typography.pxToRem(16),
              fontWeight: 'bold',
              color: '#000',
              cursor: 'pointer',
              mt: '5px',
              pb: extendClass[i] === 1 ? 0 : '24px',
            }}
            onClick={() => handleAnimation(i)}
          >
            {question}
          </Typography>

          {/* Collapsible Answer */}
          <Collapse in={extendClass[i] === 1} timeout="auto" unmountOnExit>
            <Typography
              sx={{
                fontSize: '12px',
                color: '#555',
                lineHeight: 1.5,
                mt: 1,
                pb: 2,
              }}
            >
              {description}
            </Typography>
          </Collapse>
        </Box>

        {/* +/- Icon */}
        <IconButton
          onClick={() => handleAnimation(i)}
          sx={{
            padding: 0,
            '&:hover': {
              backgroundColor: '#fff',
            },
          }}
        >
          <Typography
            sx={{
              fontSize: '24px',
              color:
                i === 0 && extendClass[i] === 1
                  ? 'transparent'
                  : extendClass[i] === 1
                  ? '#7e7e7e'
                  : '#333333',
            }}
          >
            {i === 0 && extendClass[i] === 1
              ? ''
              : extendClass[i] === 1
              ? '-'
              : '+'}
          </Typography>
        </IconButton>
      </Box>
    </Box>
  );

  return (
    <Box
      sx={{
        backgroundColor: 'primary.contrastText',
        paddingBottom: '1px',
        padding: '15px 18px 0 19px',
      }}
    >
      <Typography
        sx={{
          width: 'fit-content',
          margin: 'auto',
          marginBottom: '40px',
          fontSize: theme.typography.pxToRem(30),
          fontWeight: 'bold',
          color: 'border.deepNavy',
          textAlign: 'center',
        }}
      >
        Frequently Asked Questions
      </Typography>
      <Box sx={{maxWidth: '817px', width: '100%', margin: 'auto'}}>
        {FAQquestions.map((eachPoint, i) =>
          FAQquestionsWrapper(i, eachPoint.question, eachPoint.description)
        )}
      </Box>
    </Box>
  );
};

export default FAQ;
